import './Whatsapp.css'
import zapimg from '../../assets/whatsapp.png'

function WhatsappImg(){
    return(     
        <div className='whatsapp'>
            <a href="https://wa.me//5584994733788" target='_blank'>
                <img src={zapimg} alt='Fale conosco no whatsapp'/>
            </a>
        </div>
    )
}
export default WhatsappImg;